export enum AvailabilityStatus {
    FREE = 'FREE',
    NOT_CHECKED = 'NOT_CHECKED',
    OCCUPIED = 'OCCUPIED',
    BOOKED = 'BOOKED',
}
